import React, {Component} from 'react';
import Atts from './weibo-module/Atts'
import ReplyBox from './weibo-module/ReplyBox'
import dataWeibo from '../data/tqq_weibo';
import dataAtts from '../data/tqq_attachment'


export default class extends Component {
    render() {
        const data = dataWeibo[this.props.index],
            atts = dataAtts[data.id] || [];

        const replyIndex = this.getReplyIndex();

        return (
            <div className="post-preview">
                <p className="weibo-time"> {data.time} </p>
                <h3 className="post-subtitle" dangerouslySetInnerHTML={{__html:data.content}} />

                { replyIndex ? <ReplyBox index={replyIndex}/>
                           : <Atts data={atts}/> }

                <p className="post-meta">
                    <a href={'http://t.qq.com/p/t/'+data.id} target="_blank" rel="">
                        <i className="fa fa-tencent-weibo" />
                    </a>&nbsp;
                    发自{data.send_from}，评论和转发数 {data.popularity}
                </p>
                <hr/>
            </div>
        )
    }

    getReplyIndex() {
        const data = dataWeibo[this.props.index],
            source_id = data.source_id;

        if(data.mark.indexOf('reply_deleted')>=0)
            return 'REPLY_DELETED';

        if(!source_id)  return false;

        for(let i=this.props.index+1; i<dataWeibo.length; i++)
            if(dataWeibo[i].id === source_id)
                return i;

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/main-content/Weibo.js